import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export class AsyncBulkAarConfirmForm extends React.PureComponent {
  static propTypes = {
    newI18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    confirmString: PropTypes.string.isRequired,
    cancelString: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    stage: PropTypes.number.isRequired,
    // extraAction is close modal action, used in no-react environment
    extraAction: PropTypes.func,
  };

  static defaultProps = {
    extraAction: () => {},
  };

  onConfirm = () => {
    this.props.onConfirm();
    this.props.extraAction();
  };

  onCancel = () => {
    this.props.onCancel();
    this.props.extraAction();
  };

  render() {
    const {
      title,
      content,
      confirmString,
      cancelString,
      loading,
      stage,
      i18n,
      newI18n,
    } = this.props;

    const stageString = [
      _TL_('Uploading file ...'),
      _TL_('Validating your access to make updates ...'),
      _TL_('Applying changes ...'),
    ];

    return (
      <div className="recommendation-async-bulk-aar-confirm-form">
        {
          !loading &&
          <button
            className={classNames('close', 'closeimage')}
            onClick={this.onCancel}
            aria-label={i18n.getString('Button_Close')}
          />
        }
        <div className="recommendation-aysnc-confirm-title">{title}</div>
        <div className="recommendation-async-confirm-content">
          {
            loading ?
              <span className="blocker">
                <span className="blocker-indicator">
                  <span className="blocker-image" />
                  <span className="blocker-text">
                    {newI18n.getString(stageString[stage])}
                  </span>
                </span>
              </span>
            : content
          }
        </div>
        {
          !loading &&
          <button
            className={classNames('btn', 'btn-hero', 'btn-confirm')}
            onClick={this.onConfirm}
          >
            {confirmString}
          </button>
        }
        {
          !loading &&
          <button
            className={classNames('btn', 'btn-default', 'btn-cancel')}
            onClick={this.onCancel}
          >
            {cancelString}
          </button>
        }
      </div>
    );
  }
}
